<template>
  <div v-if="items?.length" class="space-y-2">
    <span class="text-base font-medium block">
      {{ label }}
    </span>

    <div class="flex flex-wrap gap-2">
      <span
        @click="$emit('metadata-filter', category, item.key)"
        v-for="item in items"
        :key="item.key"
        class="px-3 py-1 cursor-pointer bg-gray-100 hover:bg-primary-blue rounded text-sm hover:text-white text-primary min-w-26 flex items-center justify-center transition-all duration-200"
      >
        {{ item.label[locale as Locale] || item.label.en }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { Locale } from "~~/types/global";
import type { MetadataDTO } from "~~/types/metadata";
export type MetadataType = "genres" | "mediums" | "styles";

const emit = defineEmits(["metadata-filter"]);

defineProps<{
  label: string;
  items: MetadataDTO[];
  category: MetadataType;
}>();

const { locale } = useI18n();
</script>
